const Carousel = (props: any) => {
    if (props.data?.length > 0) {
        return (
            <div id="carousel-banner" className="carousel carousel-inner rounded-6 mb-10" data-bs-ride="carousel" style={styles.carouselContainer}>
                {/* Custom Dot Indicators */}
                <div className="carousel-indicators" style={styles.carouselIndicators}>
                    {props.data?.map((item: any, index: number) => (
                        <button
                            type="button"
                            key={index}
                            className={`carousel-button ${index === 0 ? 'active' : ''}`}
                            data-bs-target="#carousel-banner"
                            data-bs-slide-to={index}
                            aria-current="true"
                            aria-label={`Slide ${index}`}
                            style={index === 0 ? styles.activeIndicator : styles.inactiveIndicator}
                            onMouseEnter={(e) => {
                                if (index !== 0) {
                                    e.currentTarget.style.backgroundColor = 'rgba(255, 108, 6, 0.6)';
                                    e.currentTarget.style.transform = 'scale(1.1)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (index !== 0) {
                                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
                                    e.currentTarget.style.transform = 'scale(1)';
                                }
                            }}
                        ></button>
                    ))}
                </div>

                {/* Carousel Content */}
                <div className="carousel-inner">
                    {props.data?.map((item: any, index: number) => (
                        <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`} data-bs-interval="10000">
                            <div className="card p-5 border-0 rounded-4" style={styles.carouselCard}>
                                <div className="row align-items-center">
                                    {/* TEKS */}
                                    {/* <div className="col-12 col-md-7 text-start p-8">
                                        <div className="mb-3">
                                            <p className="display-5 fw-bold text-light">{item?.title_id}</p>
                                        </div>
                                        <div>
                                            <p className="fs-4 text-light">{item?.deskripsi_id}</p>
                                        </div>
                                    </div> */}

                                    {/* GAMBAR */}
                                    <div className="col-12 col-md-12 d-flex justify-content-center mt-4 mt-md-0">
                                        <a href={item?.url} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={item?.upload_banner}
                                                alt="image-carousel"
                                                className="img-fluid"
                                                style={{
                                                    maxHeight: '400px',
                                                    width: '100%',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Navigation Arrows */}
                <button 
                    className="carousel-control-prev" 
                    type="button" 
                    data-bs-target="#carousel-banner" 
                    data-bs-slide="prev"
                    style={styles.carouselControlPrev}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#e55a00';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 108, 6, 0.5)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ff6c06';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(255, 108, 6, 0.3)';
                    }}
                >
                    <span className="carousel-control-prev-icon" aria-hidden="true" style={styles.arrowIcon}></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button 
                    className="carousel-control-next" 
                    type="button" 
                    data-bs-target="#carousel-banner" 
                    data-bs-slide="next"
                    style={styles.carouselControlNext}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#e55a00';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 108, 6, 0.5)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ff6c06';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(255, 108, 6, 0.3)';
                    }}
                >
                    <span className="carousel-control-next-icon" aria-hidden="true" style={styles.arrowIcon}></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        )
    }

    return null
}

const styles = {
    carouselContainer: {
        position: 'relative' as const
    },
    carouselBanner: {
        width: 10,
        height: 10,
        borderRadius: '100%'
    },
    carouselCard: {
        background: 'transparent',
        // backgroundColor: '#F95E2F',
        borderRadius: '50px'
    },
    carouselImage: {
        width: '100%',
        height: 'auto'
    },
    // Carousel Indicators Styling
    carouselIndicators: {
        position: 'absolute' as const,
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        display: 'flex' as const,
        gap: '8px',
        margin: 0,
        padding: 0,
        listStyle: 'none' as const
    },
    activeIndicator: {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: '#ff6c06',
        border: 'none',
        cursor: 'pointer' as const,
        transition: 'all 0.3s ease',
        opacity: 1
    },
    inactiveIndicator: {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        border: '2px solid rgba(255, 108, 6, 0.3)',
        cursor: 'pointer' as const,
        transition: 'all 0.3s ease',
        opacity: 0.7
    },
    // Navigation Arrow Styling
    carouselControlPrev: {
        position: 'absolute' as const,
        top: '50%',
        left: '20px',
        transform: 'translateY(-50%)',
        width: '50px',
        height: '50px',
        backgroundColor: '#ff6c06',
        border: 'none',
        borderRadius: '50%',
        display: 'flex' as const,
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
        cursor: 'pointer' as const,
        zIndex: 10,
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 8px rgba(255, 108, 6, 0.3)'
    },
    carouselControlNext: {
        position: 'absolute' as const,
        top: '50%',
        right: '20px',
        transform: 'translateY(-50%)',
        width: '50px',
        height: '50px',
        backgroundColor: '#ff6c06',
        border: 'none',
        borderRadius: '50%',
        display: 'flex' as const,
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
        cursor: 'pointer' as const,
        zIndex: 10,
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 8px rgba(255, 108, 6, 0.3)'
    },
    arrowIcon: {
        width: '20px',
        height: '20px',
        filter: 'brightness(0) invert(1)'
    }
};

export default Carousel